import { render, staticRenderFns } from "./DropdownTrigger.vue?vue&type=template&id=3d26a56d&"
import script from "./DropdownTrigger.vue?vue&type=script&lang=js&"
export * from "./DropdownTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports